import React from 'react';
import ParentsContent from '../Components/Parents/ParentsContent';
import LoginLayout from '../Layouts/LoginLayout';

export default function Parents() {
  return (
    <LoginLayout>
        <ParentsContent />
    </LoginLayout>
  )
}
